import React from 'react';

const ContactSection = ({ t }: any) => (
  <section id="contact" className="contact-section">
    <div className="contact-block">
      <h2>{t.contact}</h2>
      <p>Email: drimaktiv@gmail.com</p>
      <p>Phone: +389 78 984 110</p>
      <div className="social-icons">
        <a href={t.contactInfo.facebookUrl} target="_blank" rel="noopener noreferrer" aria-label={t.contactInfo.facebook} style={{marginRight: 12}}>
          <img src={process.env.PUBLIC_URL + '/assets/facebook.png'} alt="Facebook" width={24} height={24} style={{display: 'inline-block', verticalAlign: 'middle'}} />
        </a>
        <a href={t.contactInfo.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label={t.contactInfo.instagram}>
          <img src={process.env.PUBLIC_URL + '/assets/instagram.png'} alt="Instagram" width={24} height={24} style={{display: 'inline-block', verticalAlign: 'middle'}} />
        </a>
      </div>
      <a href="#get-in-touch" className="btn secondary">{t.getInTouch}</a>
    </div>
  </section>
);

export default ContactSection;
